module.exports = __webpack_public_path__ + "static/media/breadcrumb-tail-flat-unselected.6f8a6bb8.svg";